/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetDataSecondStage200ResponseDataMktuListInner } from './GetDataSecondStage200ResponseDataMktuListInner'
import {
  GetDataSecondStage200ResponseDataMktuListInnerFromJSON,
  GetDataSecondStage200ResponseDataMktuListInnerFromJSONTyped,
  GetDataSecondStage200ResponseDataMktuListInnerToJSON,
} from './GetDataSecondStage200ResponseDataMktuListInner'

/**
 *
 * @export
 * @interface GetDataSecondStage200ResponseData
 */
export interface GetDataSecondStage200ResponseData {
  /**
   * Выбранные классы МКТУ
   * @type {Array<GetDataSecondStage200ResponseDataMktuListInner>}
   * @memberof GetDataSecondStage200ResponseData
   */
  mktuList: Array<GetDataSecondStage200ResponseDataMktuListInner>
}

/**
 * Check if a given object implements the GetDataSecondStage200ResponseData interface.
 */
export function instanceOfGetDataSecondStage200ResponseData(
  value: object
): value is GetDataSecondStage200ResponseData {
  if (!('mktuList' in value) || value['mktuList'] === undefined) return false
  return true
}

export function GetDataSecondStage200ResponseDataFromJSON(
  json: any
): GetDataSecondStage200ResponseData {
  return GetDataSecondStage200ResponseDataFromJSONTyped(json, false)
}

export function GetDataSecondStage200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataSecondStage200ResponseData {
  if (json == null) {
    return json
  }
  return {
    mktuList: (json['mktuList'] as Array<any>).map(
      GetDataSecondStage200ResponseDataMktuListInnerFromJSON
    ),
  }
}

export function GetDataSecondStage200ResponseDataToJSON(
  value?: GetDataSecondStage200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    mktuList: (value['mktuList'] as Array<any>).map(
      GetDataSecondStage200ResponseDataMktuListInnerToJSON
    ),
  }
}
